import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./auth";

/** Gate for the authenticated app. Unauthenticated visitors are sent to /login
 *  with the attempted path so login can return them there. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, sessionExpired } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    // Carry the full attempted path (incl. query) so login can return them there,
    // and whether this bounce was a mid-session expiry (vs. a never-signed-in visit).
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/login" replace state={{ from, expired: sessionExpired }} />;
  }
  return <>{children}</>;
}
